import { MessageType } from '@components/chat/types'
import { Conversation } from '@features/conversation/components/Conversation'
import { useGetConversation } from '@features/conversation/hooks/useGetConversation'
import { useParams } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export const ConversationPage = () => {
  const { id } = useParams({ strict: false })
  const [messages, setMessages] = useState<Array<MessageType>>([])
  const { data, isSuccess, isError } = useGetConversation(id)

  useEffect(() => {
    if (isSuccess && !!data) {
      setMessages(data.messages)
    }
    if (isError) {
      setMessages([])
    }
  }, [data])

  return (
    <Conversation
      chatId={id}
      messages={messages}
      setMessages={setMessages}
    />
  )
}
